import { DomainUploadedFile } from 'src/shared/types/uploadedFile';

import { Link } from 'src/shared/components/ui';

interface ShipmentFileLinksProps {
  files: DomainUploadedFile[];
}

/** A shipment's external files as links that open in a new tab. */
const ShipmentFileLinks: React.FC<ShipmentFileLinksProps> = ({ files }) => (
  <div className="flex gap-2 flex-wrap">
    {files.map((file) => (
      <Link key={file.id} isExternal to={file.url}>
        <span className="break-all">{file.name}</span>
      </Link>
    ))}
  </div>
);

export default ShipmentFileLinks;
